import React, { useMemo, useState } from "react";
import { CircularProgress, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Button from "@mui/material/Button";
import { jwtDecode } from "jwt-decode";
import useAuth from "../../../auth/useAuth";
import "./AuthInfo.css";

const AuthInfo = (props) => {
    const { displayError, logOut } = props;

    const { azureAccessToken, apiAccessToken, apiUser } = useAuth();
    const [showTechnicalInformation, setShowTechnicalInformation] = useState(false);

    const isInvalidAccount = false;

    const azureUser = useMemo(() => {
        try {
            return azureAccessToken ? jwtDecode(azureAccessToken) : null;
        } catch {
            return null;
        }
    }, [azureAccessToken]);

    const renderMultipleAccountError = () => (
        <>
            <Typography variant="h1">Multiple Accounts Detected</Typography>
            <Typography variant="body1">
                Your browser is currently logged in with
                {" "}
                <b>multiple accounts</b>
                .
            </Typography>
            <Typography variant="body1">
                {"Please use the "}
                <b>logout</b>
                {" button below to log out of each"}
                <b>non-Pupil account</b>
            </Typography>
            <Button className="Button-filled" sx={{ mt: 2 }} onClick={logOut}>
                Log Out
            </Button>
        </>
    );

    const renderGenericError = () => (
        <>
            <Typography variant="h1">Authentication Error</Typography>
            <Typography variant="body1">
                Please ensure you have signed in using an email address that has permission to use this portal.
            </Typography>
            <Button className="Button-filled" sx={{ mt: 2 }} onClick={logOut}>
                Log Out
            </Button>
            <Button onClick={() => setShowTechnicalInformation((v) => !v)}>
                {showTechnicalInformation ? "Hide technical information" : "Show technical information"}
            </Button>
            {showTechnicalInformation && (
                <div className="AuthInfo__details">
                    <Typography variant="body1">
                        <u><b>Technical Information</b></u>
                    </Typography>
                    <Typography variant="body1">
                        {"Active Directory: "}
                        {azureUser ? "true" : "false"}
                        <br />
                        {"Email: "}
                        {azureUser?.email ?? "No email found"}
                        <br />
                        {"Middleware: "}
                        {apiAccessToken && apiUser ? "true" : "false"}
                        <br />
                        {"Email: "}
                        {apiUser?.email ?? "No email found"}
                    </Typography>
                </div>
            )}
        </>
    );

    if (!displayError) {
        return (
            <div className="AuthInfo">
                <CircularProgress className="AuthInfo__loader" size={100} />
                <Typography variant="h1">Authenticating</Typography>
                <Typography variant="body1">Please wait</Typography>
            </div>
        );
    }

    return (
        <div className="AuthInfo">
            <ErrorOutlineIcon fontSize="inherit" color="inherit" className="AuthInfo__icon" />
            {isInvalidAccount ? renderMultipleAccountError() : renderGenericError()}
        </div>
    );
};

export default AuthInfo;
